(function() {
  'use strict';

  function run() {
    var el = document.getElementById('breadcrumb-from-referrer');
    if (!el || !document.referrer) return;

    try {
      var ref = new URL(document.referrer);
      if (ref.origin !== window.location.origin) return;

      var path = ref.pathname.replace(/\/$/, '');
      var label, href;
      var collectionMatch = path.match(/\/collections\/([^/]+)/);

      if (collectionMatch) {
        href = path.indexOf('/products/') !== -1 ? path.split('/products/')[0] : path;
        label = collectionMatch[1].replace(/-/g, ' ').replace(/\b\w/g, function(c) {
          return c.toUpperCase();
        });
      } else if (path.indexOf('/search') !== -1) {
        href = document.referrer;
        label = 'Search results';
      } else {
        return;
      }

      el.innerHTML =
        '<a href="' +
        href.replace(/"/g, '&quot;') +
        '" class="text-xs link whitespace-nowrap text-grey-700" title="' +
        label.replace(/"/g, '&quot;') +
        '">' +
        label.replace(/</g, '&lt;').replace(/>/g, '&gt;') +
        '</a>';
      el.classList.remove('after:content-none');
      el.removeAttribute('hidden');
      el.removeAttribute('aria-hidden');
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
